import Vue from "vue";

import DeleteAccount from "./DeleteAccount.vue";

export function load() {
    const selector = "delete-account";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(DeleteAccount, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
